import { BCMSRecord, useBCMSContext, useParams, Workflow } from "@bcm-dev/bcms-vite";
import Classes, { Account, Document } from "model";
import React from "react";

import OSGStatementsPage from "components/pages/OSGStatementsPage";
import OSGStatementSearchItem from "./classes/OSGStatementSearchItem";
// Steps of the workflow
const steps = [ 
    OSGStatementsPage, 
 ];

/**
 * @function OSGStatementsWorkflow
 * @returns {React.Component}
 * @exported true
 * @description The main workflow component for "OSG Statements".
 * @example
 * <OSGStatementsWorkflow />
 */
export default function OSGStatementsWorkflow(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { stepID } = useParams();

    const value = getDefaultData(context);
    return <Workflow value={ value } steps={ steps } step={ stepID }  />
}

/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @exported true
 * @description Hook to return the steps of the workflow
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefaultData
 * @returns {OBJECT}
 * @exported true
 * @description Hook to return the default state of the workflow
 */
export const getDefaultData = (controller) => {
    let branding = {};
    let options = {}
    let showAllAccountsOption = true;
    const firstAccountID = Account.initAll()[0].id;
    const documents = Document.sortDateAscending(Document.initAll());

    if(controller) {
        branding = controller.state.branding;
        options = controller.state.branding.options;
        showAllAccountsOption = options.allaccts_statements_abi22 === "true";
    }

    return {
        data: {
                search: OSGStatementSearchItem.init({ 
                    account: showAllAccountsOption ? "all" : `${ Account.initAll()[0].id }`,
                    filtered: showAllAccountsOption ? documents : documents.filter(item => item.account.id === firstAccountID)
                }),
                branding: branding,
                showAllAccountsOption
            },
        ui: {
    accountDD: { isActive: false }, 
}
    }
};